import { useState } from 'react';

export default function ServiceGallery({ service }) {
  const images = (service.images || []).filter((i) => i.url);
  const cover = images.find((i) => i.is_cover) || images[0];
  const [active, setActive] = useState(cover?.url || service.image || null);

  if (!active) return null;

  return (
    <div className="mb-8" data-testid={`service-gallery-${service.id}`}>
      <div className="aspect-[4/3] overflow-hidden bg-muted">
        <img
          src={active}
          alt={service.title}
          className="w-full h-full object-cover transition-opacity duration-500"
          loading="lazy"
          data-testid="service-gallery-main"
        />
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
          {images.map((img) => (
            <button
              key={img.id}
              type="button"
              onClick={() => setActive(img.url)}
              className={`shrink-0 w-16 h-16 overflow-hidden border transition-colors ${active === img.url ? 'border-foreground' : 'border-transparent hover:border-border'}`}
              aria-label={img.alt_text || service.title}
              data-testid="service-gallery-thumb"
            >
              <img src={img.thumbnail_url || img.url} alt={img.alt_text || ''} className="w-full h-full object-cover" loading="lazy" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
